import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import InputItem from '../InputItem';
import { useTranslation } from 'react-i18next';
export const initialData = {
    password: '',
    password_confirmation: '',
};
const NewPasswordForm = ({ setData, data, errors, processing, }) => {
    const { t } = useTranslation();
    return (_jsxs(_Fragment, { children: [_jsx(InputItem, { label: t('users.new_password_title'), placeholder: t('users.password_placeholder'), type: "password", onChange: e => setData('password', e.target.value), error: errors?.password, value: data?.password, disabled: processing, required: true }), _jsx(InputItem, { label: t('users.password_confirmation_title'), placeholder: t('users.password_confirmation_placeholder'), type: "password", onChange: e => setData('password_confirmation', e.target.value), error: errors?.password_confirmation, value: data?.password_confirmation, disabled: processing, required: true })] }));
};
export default NewPasswordForm;
